import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  activeSettingsComponentWrapper: {
    paddingLeft: Theme.px(195),
  },
  linearGradient: {
    height: Theme.px(1080),
    width: Theme.px(1515),
  },
});
